

function getZoomForCountryCode(countryCode) {
    switch(countryCode) {
        case 'HR': return [45.815399, 15.966568];
        case 'AT': return [48.208176, 16.373819];
        case 'FI': return [60.169857, 24.938379];
        case 'BA': return [43.856430, 18.413420];
        case 'EE': return [59.436962, 24.753574];
        case 'FR': return [48.864716, 2.349014];
        case 'BE': return [50.850346, 4.351721];
        case 'BG': return [42.697708, 23.321868];
        case 'GR': return [37.983810, 23.727539];
        case 'DE': return [52.520008, 13.404954];
        case 'HU': return [47.497913, 19.040236];
        case 'IT': return [41.902782, 12.496366];
        case 'LT': return [54.687157, 25.279652];
        case 'LU': return [49.611621, 6.131935];
        case 'IE': return [53.349805, -6.260310];
        case 'ME': return [42.430420, 19.259364];
        case 'LV': return [56.949649, 24.105186];
        case 'NL': return [52.370216, 4.895168];
        case 'PT': return [38.722252, -9.139337];
        case 'PL': return [52.229676, 21.012229];
        case 'RO': return [44.426765, 26.102537];
        case 'CZ': return [50.075539, 14.437800];
        case 'DK': return [55.676097, 12.568337];
        case 'RS': return [44.786568, 20.448922];
        case 'SI': return [46.056947, 14.505751];
        case 'SK': return [48.148598, 17.107748];
        case 'ES': return [40.416775, -3.703790];
        case 'SE': return [59.329323, 18.068581];
        case 'TR': return [41.008238, 28.978359];
        case 'CH': return [46.818188, 8.227512];
        case 'GB': return [51.507351, -0.127758];
        case 'MK': return [41.997346, 21.427996];
        case 'NO': return [59.913869, 10.752245];
        case 'MD': return [47.010452, 28.863810];
        case 'CN': return [39.904202, 116.407394];
        case 'HK': return [22.396428, 114.109497];
        case 'MA': return [31.791702, -7.092620];
        case 'CA': return [45.421530, -75.697193];
        case 'TW': return [25.032969, 121.565414];
        case 'JP': return [35.689487, 139.691711];
        case 'KR': return [37.566535, 126.977969];
        case 'TH': return [13.756331, 100.501762];
        case 'MY': return [3.139003, 101.686855];
        case 'LA': return [19.856270, 102.495496];
        case 'UA': return [50.450100, 30.523399];
        case 'SG': return [1.352083, 103.819839];
        case 'EG': return [30.044420, 31.235712];
        case 'AR': return [-34.603722, -58.381592];
        case 'BR': return [-15.826691, -47.921820];
        case 'CL': return [-33.448890, -70.669265];
        case 'GE': return [41.715137, 44.827095];
        case 'US': return [38.907192, -77.036873];
        case 'NZ': return [-41.286460, 174.776236];
        case 'AM': return [40.179186, 44.499103];
        case 'UZ': return [41.299496, 69.240073];
        case 'KZ': return [51.160523, 71.470356];
        case 'ZA': return [-25.747868, 28.229271];
        case 'AU': return [-35.280937, 149.130005];
        case 'AZ': return [40.409262, 49.867092];
        case 'IN': return [28.613939, 77.209023];
        case 'MC': return [43.738418, 7.424616];
        case 'KG': return [42.874621, 74.569761];
        case 'SA': return [24.713552, 46.675296];
        case 'AF': return [34.555349, 69.207486];
        case 'RU': return [55.755825, 37.617298];
        case 'BY': return [53.904540, 27.561524];
        case 'AL': return [41.327546, 19.818698];
        case 'PK': return [33.684420, 73.047884];
        case 'LK': return [6.927079, 79.861244];
        case 'IL': return [31.768319, 35.213710];
        case 'JO': return [31.956578, 35.945695];
        case 'IR': return [35.689197, 51.388974];
        case 'NP': return [27.717245, 85.323960];
        case 'MM': return [16.840697, 96.173401];
        case 'ID': return [-6.175110, 106.865036];
        case 'VN': return [21.027763, 105.834160];
        case 'MN': return [47.886398, 106.905744];
        case 'TJ': return [38.573315, 68.786157];
        case 'TM': return [38.969719, 59.556278];
        case 'NG': return [9.076479, 7.398574];
        case 'KE': return [-1.292066, 36.821946];
        case 'TZ': return [-6.369028, 34.888822];
        case 'PH': return [14.599512, 120.984222];
        case 'GH': return [5.603717, -0.186964];
        case 'DZ': return [36.753768, 3.058756];
        case 'TN': return [36.806496, 10.181532];
        case 'BD': return [23.810332, 90.412518];
        case 'KH': return [11.556374, 104.928209];

        default: return [0, 0];
    }
}

// Determining tile layers

function getTileLayerForUser(user) {
    const selectedBackground = user ? (user.preferences.selectedBackground ? user.preferences.selectedBackground : undefined) : undefined

    if (!selectedBackground) {
      return getTileLayerForSelectedBackground('default')
    }

    return getTileLayerForSelectedBackground(selectedBackground)
  }

function getTileLayerForSelectedBackground(selectedBackground) {
    const GEOAPIFY_API_KEY = process.env.REACT_APP_GEOAPIFY_API_KEY
    const THUNDERFORST_API_KEY = process.env.REACT_APP_THUNDERFORST_API_KEY

    const standardAttribution = '© <a href="http://osm.org/copyright">OpenStreetMap</a>'
    const geoapifyAttribution = `${standardAttribution} | Powered by <a href="https://www.geoapify.com/">Geoapify</a>`
    const googleAttribution = '<a href="https://opendatacommons.org/licenses/odbl/">ODbL</a>'

    switch(selectedBackground) {
        case 'default': return { 
            provider: 'google',
            attribution: googleAttribution,
        }
        case 'satelite': return { 
            provider: 'google',
            attribute: 'hybrid',
            attribution: googleAttribution,
        }
        case 'default-osm':
        case 'default-osm-fr': // Legacy fr/intl option in case the user doesn't reload the object, can be removed later
        case 'default-osm-intl': return { 
            provider: 'osm',
            url: `https://maps.geoapify.com/v1/tile/osm-carto/{z}/{x}/{y}.png?&apiKey=${GEOAPIFY_API_KEY}`, 
            attribution: geoapifyAttribution,
        }
        case 'flat-osm': return {
            provider: 'osm',
            url: `https://tile.thunderforest.com/atlas/{z}/{x}/{y}.png?apikey=${THUNDERFORST_API_KEY}`,
            attribution: standardAttribution,        
        }
        case 'transport-osm': return {
            provider: 'osm',
            url: `https://tile.thunderforest.com/transport/{z}/{x}/{y}.png?apikey=${THUNDERFORST_API_KEY}`,
            attribution: standardAttribution,
        }
        case 'transport-vintage-osm': return {
            provider: 'osm',
            url: `https://tile.thunderforest.com/pioneer/{z}/{x}/{y}.png?apikey=${THUNDERFORST_API_KEY}`,
            attribution: standardAttribution,
        }
    }
}

// Polylines & markers

function isBrightForSelectedBackground(selectedBackground) {
    return selectedBackground === 'satelite'
}

const polylineValues = {
    standardColor: '#313497',
    standardUpcomingColor: '#336600',
    unmappedColor: '#000000',
    highlightedColor: '#CC0000',

    standardColorBright: '#00FFFF',
    standardUpcomingColorBright: '#00CC00',
    unmappedColorBright: '#808080',

    defaultOpacity: 0.8,
    defaultWeight: 3,
    upcomingDashArray: '3, 5',
}

const polylinePathOptions = {
    standard: { 
        color: polylineValues.standardColor,
        defaultWeight: polylineValues.defaultWeight,
        opacity: polylineValues.defaultOpacity,
    },
    standardUpcoming: { 
        color: polylineValues.standardUpcomingColor, 
        defaultWeight: polylineValues.defaultWeight,
        opacity: polylineValues.defaultOpacity,
        dashArray: polylineValues.upcomingDashArray, 
        lineCap: 'square',
    },
    unmapped: {
        color: polylineValues.unmappedColor, 
        defaultWeight: polylineValues.defaultWeight,
        opacity: 0.5,
    },
    unmappedUpcoming: { 
        color: polylineValues.unmappedColor, 
        defaultWeight: polylineValues.defaultWeight,
        opacity: 0.3,
        dashArray: polylineValues.upcomingDashArray, 
        lineCap: 'square', 
    },

    standardBright: {
        color: polylineValues.standardColorBright,
        defaultWeight: polylineValues.defaultWeight,
        opacity: polylineValues.defaultOpacity,
    },
    standardUpcomingBright: { 
        color: polylineValues.standardUpcomingColorBright, 
        defaultWeight: polylineValues.defaultWeight,
        opacity: polylineValues.defaultOpacity,
        dashArray: polylineValues.upcomingDashArray, 
        lineCap: 'square',
    },
    unmappedBright: {
        color: polylineValues.unmappedColorBright, 
        defaultWeight: polylineValues.defaultWeight,
        opacity: 0.5,
    },
    unmappedUpcomingBright: { 
        color: polylineValues.unmappedColorBright, 
        defaultWeight: polylineValues.defaultWeight,
        opacity: 0.3,
        dashArray: polylineValues.upcomingDashArray, 
        lineCap: 'square', 
    },

    highlighted: { 
        color: polylineValues.highlightedColor,
        defaultWeight: polylineValues.defaultWeight,
        opacity: polylineValues.defaultOpacity,
    },
}

function getLinesForJourneys(journeys, selectedBackground) {
    const lines = []
    const isBright = isBrightForSelectedBackground(selectedBackground)

    for (const journey of journeys) {
        if (journey.route.positions.length !== 0) {
          if ((new Date(journey.date)) <= (new Date())) {
            lines.push({
                positions: journey.route.positions,
                pathOptions: !isBright ? polylinePathOptions.standard : polylinePathOptions.standardBright,
            })
          } else {
            lines.push({
                positions: journey.route.positions,
                pathOptions: !isBright ? polylinePathOptions.standardUpcoming : polylinePathOptions.standardUpcomingBright,
            })
          }
        } else {
          // Cases where the route between two stations is not determined
          const positions = [[journey.from.latitude, journey.from.longitude], [journey.to.latitude, journey.to.longitude]]
  
          if ((new Date(journey.date)) <= (new Date())) {
            lines.push({
                positions: positions,
                pathOptions: !isBright ? polylinePathOptions.unmapped : polylinePathOptions.unmappedBright,
            })
          } else {
            lines.push({
                positions: positions,
                pathOptions: !isBright ? polylinePathOptions.unmappedUpcoming : polylinePathOptions.unmappedUpcomingBright,
            })
          }
        }
    }
      
    return lines
}

function getLineForCustom(positions, variant) {
    if (variant === 'preview') {
        return [{
            positions: positions,
            pathOptions: polylinePathOptions.highlighted,
        }]
    }
}

function getLinesForCreatorMap(map) {
    const output = []

    for (const layer of map.layers) {
        if (layer.line) {
            const color = layer.line.color ? layer.line.color : '#000000'
            const variant = layer.line.variant ? layer.line.variant : 'solid'
            const opacity = layer.line.opacity ? layer.line.opacity : polylineValues.defaultOpacity

            output.push({
                positions: layer.line.positions,
                pathOptions: {
                    color: color,
                    defaultWeight: polylineValues.defaultWeight,
                    opacity: opacity,
                    dashArray: variant === 'dashed' ? '3, 5' : undefined,
                    lineCap: variant === 'dashed' ? 'square' : undefined,
                },
            })
        }
    }

    return output
}

function getMarkersForJourneys(journeys, selectedBackground) {
    const markers = []
    const isBright = isBrightForSelectedBackground(selectedBackground)

    for (const journey of journeys) {
        const originPoint = {
            stationName: journey.from.name,
            position: [journey.from.latitude, journey.from.longitude]
        }
        const destinationPoint = {
            stationName: journey.to.name,
            position: [journey.to.latitude, journey.to.longitude]
        }

        if ((new Date(journey.date)) <= (new Date())) {
            markers.push({
                properties: originPoint,
                variant: !isBright ? 'default' : 'default-bright'
            })
            markers.push({
                properties: destinationPoint,
                variant: !isBright ? 'default' : 'default-bright'
            })
        } else {
            markers.push({
                properties: originPoint,
                variant: !isBright ? 'upcoming' : 'upcoming-bright'
            })
            markers.push({
                properties: destinationPoint,
                variant: !isBright ? 'upcoming' : 'upcoming-bright'
            })
        }
    }
    
    return markers
}

function getMarkersForCreatorMap(map) {
    const output = []

    for (const layer of map.layers) {
        if (layer.marker) {
            var variant = 'default'
            if (layer.marker.variant === 'outline')
                variant = 'upcoming'

            output.push({
                properties: {
                    stationName: 'Custom point',
                    position: layer.marker.position,
                },
                variant: variant,
            })
        }

        // Start/end markers of lines
        if (layer.line) {
            if (layer.line.startMarker) {
                output.push({
                    properties: {
                        stationName: 'Start',
                        position: layer.line.startMarker.position,
                    },
                    variant: 'default',
                })
            }

            if (layer.line.endMarker) {
                output.push({
                    properties: {
                        stationName: 'End',
                        position: layer.line.endMarker.position,
                    },
                    variant: 'default',
                })
            }
        }
    }

    return output
}

export {
    getZoomForCountryCode,
    getTileLayerForUser,
    getTileLayerForSelectedBackground,

    getLinesForJourneys,
    getLineForCustom,
    getLinesForCreatorMap,
    getMarkersForJourneys,
    getMarkersForCreatorMap,
}